// Shared key-building helpers for the per-row-entity completeness ("Needed") highlighting.
// A per-row-entity (Borrower/Reo/Income/Asset/Liability) completeness checklist runs once PER
// ROW, so its snapshot items share the same `fieldRef` leaf across every row — keying the
// `selectIncompleteLinkedFields` map by (leaf, entityId) via `getEntityScopedFieldKey` keeps each
// row's entry distinct. `FieldPresenceWrapper` resolves the SAME entityId out of its
// entity-scoped `fieldPath` (`[<entityId>].leafPath`, mirroring how `validationErrors` are
// already resolved per row in the editor forms) via `extractEntityIdFromFieldPath` so the lookup
// matches the selector's key. Originally borrower-only (DEV-4684); generalized to every
// financial-info row type in DEV-5801.

const ENTITY_FIELD_KEY_SEPARATOR = '::';

const BRACKET_ENTITY_ID_PATTERN = /^\[([^\]]+)\]/;

export const getEntityScopedFieldKey = (leafFieldId, entityId) =>
  `${leafFieldId}${ENTITY_FIELD_KEY_SEPARATOR}${entityId}`.toLowerCase();

// An entity-scoped field's `fieldPath` (the FormGenerator `nameInModel`, lowercased) is
// bracket-prefixed with the entity id, e.g. `[3fa8...].maritalstatus`. Returns null when the
// path isn't entity-scoped (loan-level fields have no leading bracket).
export const extractEntityIdFromFieldPath = fieldPath => {
  const match = BRACKET_ENTITY_ID_PATTERN.exec(fieldPath ?? '');

  return match ? match[1].toLowerCase() : null;
};
